<!-- main banner  -->
<div class="collab-banner sticky-header-banner banner-sec black-text">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative">
           
            <div class="z-index pb-2">
                <div class="row mx-0 m-col-width">
                    <div class="col-md-6 col-sm-12 px-0 m-mb">
                        <div class="whats-new-label dark-banner">
                            <div class="wave-container">
                                <div class="wave-dot wave-dot-1"></div> 
                                <div class="wave-dot wave-dot-3"></div> 
                            </div> 
                            <span class="primary-color paragraph-global-text sub-head-paragraph">
                                {{'fileSharing.banner.preTitle' | translate}}
                            </span>
                        </div>
        
                        <h1 class="banner-heading mw-700">{{'fileSharing.banner.headline1' | translate}} {{'fileSharing.banner.headline2' | translate}}</h1>
                        <p class="paragraph-global-text mw-500">{{'fileSharing.banner.subheadline' | translate}}</p>
                       <div class="d-flex align-items-center my-3">
                            <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                                <button class="save-btn">
                                    {{'fileSharing.banner.ctaButtons.btnText' | translate}}
                                </button>
                            </a>
                            <a [routerLink]="['/en/book-demo']" target="_blank">
                                <button class="save-btn cfa ml-3">
                                    {{'fileSharing.banner.ctaButtons.btnText2' | translate}}
                                    <i class="pi pi-arrow-right title-color ml-2"></i>
                                </button>
                            </a>
                       </div>                      
                    </div>
                    <div class="col-md-6 col-sm-12 pr-0 d-flex align-items-center">
                        <figure>
                            <img class="w-100 pl-4" width="300" src="../../../assets/icons/find-answers/find-answer-banner.svg" alt="find answers">
                        </figure>
                    </div>
                </div>                
            </div>           
        </div>
    </div>
</div>



<div class="sec-padding">    
    <div class="container z-index">
        <div class="row mx-0 m-col-w card-v-gap justify-content-between">            
            <div class="col-md-6 col-sm-12">
                <div class="h-100 d-flex flex-column justify-content-center">
                    <div class="rounded-img-bg p-3 mr-auto mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-share icon-primary-color"><path d="M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7"></path><path d="M16 3h5v5"></path><path d="m16 8 5-5"></path></svg>
                    </div>
                    <h2 class="heading-one mw-600">{{'fileSharing.share.title' | translate}}</h2>
                    <p class="paragraph-global-text sub-head-paragraph mw-600 mb-0">{{'fileSharing.share.description' | translate}}</p>
                </div>
            </div>
            <div class="col-md-5 col-sm-12 d-flex align-items-center">
                <figure>
                    <img class="card-image w-100 box-shadow border-radius" src=".././../../assets/icons/find-insights/find-insights-sec-img.svg" alt="card-image">
                </figure>
            </div>
        </div>
    </div>
</div>

<div class="sec-padding secondary-bg-color">    
    <div class="container z-index">
        <div class="row mx-0 m-col-w card-v-gap justify-content-between">
            <div class="col-md-5 col-sm-12 d-flex align-items-center">
                <figure>
                    <img class="card-image w-100 box-shadow border-radius" src=".././../../assets/icons/find-insights/find-insights-sec-img.svg" alt="card-image">
                </figure>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="h-100 d-flex flex-column justify-content-center">
                    <div class="rounded-img-bg p-3 mr-auto mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-folder-input icon-primary-color"><path d="M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1"></path><path d="M2 13h10"></path><path d="m9 16 3-3-3-3"></path></svg>
                    </div>
                    <h2 class="heading-one mw-500">{{'fileSharing.onePlace.title' | translate}}</h2>
                    <p class="paragraph-global-text sub-head-paragraph mw-550 mb-0">{{'fileSharing.onePlace.description' | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="sec-padding">    
    <div class="container z-index">
        <div class="row mx-0 m-col-w card-v-gap justify-content-between">           
            <div class="col-md-6 col-sm-12">
                <div class="h-100 d-flex flex-column justify-content-center">
                    <div class="rounded-img-bg p-3 mr-auto mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users icon-primary-color"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                    </div>
                    <h2 class="heading-one mw-600">{{'fileSharing.realTime.title' | translate}}</h2>
                    <p class="paragraph-global-text sub-head-paragraph mw-600 mb-0">{{'fileSharing.realTime.description' | translate}}</p>
                </div>
            </div>
            <div class="col-md-5 col-sm-12 d-flex align-items-center">
                <figure>
                    <img class="card-image w-100 box-shadow border-radius" src=".././../../assets/icons/find-insights/find-insights-sec-img.svg" alt="card-image">
                </figure>
            </div>
        </div>
    </div>
</div>


<div class="sec-padding secondary-bg-color">    
    <div class="container">
        <div class="row mx-0 m-col-width">
            <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards banner-img-card">
                    <img class="mb-2" width="200" src="../../../assets/icons/contract-talent/contract-benefits/contract-benefit-1.svg" alt="">
                     <h4 class="heading-three pt-4">{{'fileSharing.fileSharingBenefits.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'fileSharing.fileSharingBenefits.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards banner-img-card">
                    <img class="mb-2" width="200" src="../../../assets/icons/contract-talent/contract-benefits/contract-benefit-2.svg" alt="">
                     <h4 class="heading-three pt-4">{{'fileSharing.fileSharingBenefits.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'fileSharing.fileSharingBenefits.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards banner-img-card">
                    <img class="mb-2" width="200" src="../../../assets/icons/contract-talent/contract-benefits/contract-benefit-3.svg" alt="">
                     <h4 class="heading-three pt-4">{{'fileSharing.fileSharingBenefits.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'fileSharing.fileSharingBenefits.section3.description' | translate}}</p>
                </div>
             </div>
        </div>
    </div>
</div>

<div class="sec-padding cfa-sec position-relative">    
      <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">
            <h2 class="heading-one text-white mx-auto">{{'fileSharing.cfa.title' | translate}} </h2>
            <p class="paragraph-global-text sub-head-paragraph mw-650 text-white">{{'fileSharing.cfa.description' | translate}}</p>
  
            <div class="button-container mt-4">
                <a class="save-btn btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                    {{'fileSharing.cfa.buttonTxt' | translate}}
                </a>
                <a class="save-btn cfa btn" [routerLink]="['/en/book-demo']" target="_blank">
                    {{'fileSharing.cfa.buttonTxt2' | translate}}
                </a>
            </div>
        </div>
    </div>
  </div>